<template>
    <zen-one
        :showuserinfo="false"
        :crumbs="crumbs"
        title="Sistem Hasil Bersepadu Kedah (iHasil)"
    >
        <z-page
            class="table-hardcode"
            content-class="pa0"
            title="Bayaran Balik Bantuan - Daftar"
        >
            <div class="message-box">
                <w-transition-fade>
                    <w-alert
                        class="my0 text-light"
                        v-if="form.submitted"
                        success
                        no-border
                    >
                        The form is valid, ready to send it!
                    </w-alert>

                    <w-alert
                        class="my0 text-light"
                        v-else-if="form.valid === false"
                        error
                        no-border
                    >
                        Terdapat {{ form.errorsCount }} ralat di dalam borang
                        ini.
                    </w-alert>
                </w-transition-fade>
            </div>

            <w-dialog
                v-model="dialog.show"
                :fullscreen="dialog.fullscreen"
                :width="dialog.width"
                :persistent="dialog.persistent"
                :persistent-no-animation="dialog.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title> Tambah Profil </template>
                <template #default>
                    <w-form
                        ref="form"
                        v-model="dialog.valid"
                        @validate="submitProfil"
                        @success="success"
                    >
                        <template></template><br />

                        <w-flex justify-space-between class="mb4">
                            <div class="xs4">
                                <div class="title4 mb2">Kategori Profil*</div>
                                <w-radios
                                    :items="kategori"
                                    v-model="form_profil.kategori"
                                    :sort="false"
                                    :cache="false"
                                    :validators="[validators.required]"
                                    inline
                                ></w-radios>
                            </div>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                label="No. KP/No. Syarikat *"
                                name="No. ID"
                                v-model="form_profil.no_id"
                                :validators="[validators.required]"
                            />
                            <z-input
                                label="Nama *"
                                name="Nama"
                                v-model="form_profil.nama"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                label="Alamat *"
                                name="Alamat"
                                v-model="form_profil.alamat1"
                                :validators="[validators.required]"
                            />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                name="Alamat2"
                                v-model="form_profil.alamat2"
                            />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                name="Alamat3"
                                v-model="form_profil.alamat3"
                            />
                        </w-flex>
                        <z-lookup
                            label="Poskod"
                            name="poskod"
                            :url="service_utiliti + 'lookup/lkp_poskod'"
                            :sort="false"
                            :cache="false"
                            v-model="form_profil.lkp_poskod_id"
                        /><br />
                        <w-flex justify-center align-center>
                            <div class="xs6">
                                <tr>
                                    <td class="fw-semibold m0">
                                        Bandar : &nbsp;&nbsp;&nbsp;
                                    </td>
                                    <td>{{ form_profil.bandar }}</td>
                                </tr>
                            </div>
                            <div class="xs6">
                                <tr>
                                    <td class="fw-semibold m0">
                                        Negeri :&nbsp;&nbsp;&nbsp;
                                    </td>
                                    <td>{{ form_profil.negeri }}</td>
                                </tr>
                            </div> </w-flex
                        ><br />
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                label="No. Telefon"
                                name="No. Telefon"
                                v-model="form_profil.no_tel"
                                :validators="[validators.numeric]"
                            />
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <z-input
                                label="Emel"
                                name="Email"
                                v-model="form_profil.emel"
                            />
                        </w-flex>
                    </w-form>
                </template>
                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialog.show = false"
                        >Tutup</w-button
                    >
                    <w-button
                        class="ml1"
                        :loading="dialog.loading"
                        :disabled="dialog.valid === false"
                        @click="$refs.form.validate()"
                        >Simpan</w-button
                    >
                </template>
            </w-dialog>

            <w-form
                class=""
                v-model="form.valid"
                v-model:errors-count="form.errorsCount"
                @validate="onValidate"
                @success="onSuccess"
                v-if="form.show == true"
            >
                <w-flex class="mt2">
                    <div class="xs6 mr5">
                        <w-input
                            v-model="form.no_rujukan"
                            required
                            label="No. Rujukan Subsidiari *"
                            :validators="[validators.required]"
                        />
                    </div>
                    <div class="xs6 mr5">
                        <z-lookup
                            label="Skim Bantuan *"
                            :url="
                                service_utiliti +
                                'lookup/lkp_tuntutan_bantuan_skim'
                            "
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_tuntutan_bantuan_skim_id"
                            :validators="[validators.required]"
                        />
                    </div>
                </w-flex>

                <w-flex class="mt3">
                    <z-input
                        label="Nama Penerima *"
                        readonly
                        @click="profil"
                        :validators="[validators.required]"
                        v-model="form.data_profil"
                    />

                    <div class="xs1">
                        <!-- <w-icon>fal fa-search</w-icon> -->
                        &nbsp;
                        <w-icon @click="dialog.show = true">fal fa-plus</w-icon>
                    </div>
                </w-flex>
                <w-flex class="mt3">
                    <z-input
                        label="Nama Waris"
                        readonly
                        @click="profil2"
                        :validators="[validators.notrequired]"
                        v-model="form.data_profil2"
                    />

                    <div class="xs1">
                        <!-- <w-icon>fal fa-search</w-icon> -->
                        &nbsp;
                        <w-icon @click="dialog.show = true">fal fa-plus</w-icon>
                    </div>
                </w-flex>

                <br />

                <w-flex class="mt2">
                    <div class="xs6 mr5">
                        <w-input
                            v-model="form.tarikh_laporan"
                            required
                            label="Tarikh Laporan Diterima *"
                            type="date"
                            :validators="[validators.required]"
                            :max="new Date().toISOString().slice(0, 10)"
                            input-format="dd/MM/yyyy"
                        />
                    </div>
                    <div class="xs6 mr5">
                        <z-lookup
                            label="Perihal Tunggakan *"
                            :url="
                                service_utiliti +
                                'lookup/lkp_tuntutan_bantuan_perihal'
                            "
                            :sort="false"
                            :cache="false"
                            v-model="form.lkp_tuntutan_bantuan_perihal_id"
                            :validators="[validators.required]"
                            @change="handlePerihalChange"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt2">
                    <div class="xs6 mr5">
                        <w-input
                            v-model="form.tarikh_meninggal"
                            label="Tarikh Meninggal Dunia"
                            type="date"
                            :validators="[validators.notrequired]"
                            :max="new Date().toISOString().slice(0, 10)"
                        />
                    </div>
                    <!-- <div class="xs6 mr5">
                        <w-input
                            v-model="form.tarikh_meninggal"
                            label="Tarikh Terakhir Bayaran"
                            type="date"
                            :validators="[validators.notrequired]"
                            :max="new Date().toISOString().slice(0, 10)"
                        />
                    </div> -->
                    <div class="xs6 mr5">
                        <w-input
                            v-model="form.catatan"
                            label="Catatan Perihal"
                            :validators="[validators.notrequired]"
                            :disabled="!isCatatanPerihalSelectable()"
                        />
                    </div>
                </w-flex>
                <w-flex class="mt2">
                    <div class="xs6 mr5">
                        <w-input
                            v-model="form.tunggakan_dari"
                            required
                            label="Tempoh Tunggakan *"
                            type="date"
                            :validators="[validators.required]"
                            @input="updateHinggaMinDate"
                        />
                    </div>
                    <div class="xs6 mr5">
                        <w-input
                            v-model="form.tunggakan_hingga"
                            required
                            label="Hingga *"
                            type="date"
                            :validators="[validators.required]"
                            :min="form.tunggakan_dari"
                            :disabled="!form.tunggakan_dari"
                        />
                    </div>

                    <div class="xs6 mr5"></div>
                    <div class="xs6 mr5"></div>
                </w-flex>
                <w-flex class="mt2">
                    <div class="xs6 mr5">
                        <z-money
                            v-model:originalValue="form.amaun_tunggakan"
                            label="Jumlah Tuntutan (RM) *"
                            :validators="[validators.required]"
                        ></z-money>
                    </div>

                    <div class="xs6 mr5">
                        <z-money
                            v-model:originalValue="form.amaun_bulanan"
                            label="Jumlah Bantuan Bulanan (RM)"
                            @keyup="jumlah(form)"
                            :validators="[validators.notrequired]"
                        ></z-money>
                    </div>
                </w-flex>
                <w-flex class="mt2">
                    <div class="xs6 mr5">
                        <w-input
                            v-model="files"
                            label="Dokumen Tuntutan "
                            type="file"
                            :validators="[validators.required]"
                        />
                    </div>
                    <div class="xs6 mr5">
                        <w-input
                            v-model="files"
                            label="Dokumen Sokongan "
                            type="file"
                            :validators="[validators.required]"
                        />
                    </div>
                </w-flex>

                <w-flex class="mt3" wrap align-center justify-end>
                    <div class="spacer" />

                    <w-button
                        class="my1"
                        bg-color="warning"
                        dark
                        @click="back()"
                        >Kembali</w-button
                    >
                    &nbsp; &nbsp;
                    <template v-if="!form.lkp_tuntutan_bantuan_status_id">
                        <w-button
                            class="my1 error-dark1--bg"
                            dark
                            @click="reset()"
                            >Reset</w-button
                        >
                        &nbsp; &nbsp;
                    </template>

                    <w-button
                        class="my1"
                        type="submit"
                        :disabled="form.valid === false"
                        :loading="form.submitted && !form.sent"
                    >
                        <w-icon dark tile class="mr2">fal fa-save</w-icon>
                        Simpan
                    </w-button>
                </w-flex>
            </w-form>
            <!-- nama penerima -->
            <w-dialog
                v-model="dialogProfil.show"
                :fullscreen="dialogProfil.fullscreen"
                :width="dialogProfil.width"
                :persistent="dialogProfil.persistent"
                :persistent-no-animation="dialogProfil.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <w-icon class="mr2">fal fa-user</w-icon>
                    Carian Profil Penerima
                </template>
                <div class="page-wrapper-portal">
                    <w-flex justify-center align-center>
                        <div class="xs8">
                            <w-input
                                label="No KP | Nama (Carian minimun 2 aksara)"
                                v-model="carian_profil.q"
                            >
                            </w-input>
                        </div>
                        <div class="xs4">
                            <w-button class="ml1" @click="cariProfil"
                                >Cari</w-button
                            >
                        </div>
                    </w-flex>
                    <div class="table-profil-scrol">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No KP | Nama
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Pilih
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in profils">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.label }}
                                    </td>
                                    <td class="w-table__cell text-right">
                                        <w-radio
                                            class="mr2"
                                            :return-value="dt.value"
                                            @click="pilihProfil(dt)"
                                        ></w-radio>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialogProfil.show = false"
                        >Tutup</w-button
                    >
                </template>
            </w-dialog>
            <!-- nama pewaris -->

            <w-dialog
                v-model="dialogProfil2.show"
                :fullscreen="dialogProfil2.fullscreen"
                :width="dialogProfil2.width"
                :persistent="dialogProfil2.persistent"
                :persistent-no-animation="dialogProfil2.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <w-icon class="mr2">fal fa-user</w-icon>
                    Carian Profil Pewaris
                </template>
                <div class="page-wrapper-portal">
                    <w-flex justify-center align-center>
                        <div class="xs8">
                            <w-input
                                label="No KP | Nama (Carian minimun 2 aksara)"
                                v-model="carian_profil2.q"
                            >
                            </w-input>
                        </div>
                        <div class="xs4">
                            <w-button class="ml1" @click="cariProfil2"
                                >Cari</w-button
                            >
                        </div>
                    </w-flex>
                    <div class="table-profil-scrol">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        No KP | Nama
                                    </th>
                                    <th
                                        class="w-table__header w-table__header--sortable text-left"
                                    >
                                        Pilih
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in profils2">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.label }}
                                    </td>
                                    <td class="w-table__cell text-right">
                                        <w-radio
                                            class="mr2"
                                            :return-value="dt.value"
                                            @click="pilihProfil2(dt)"
                                        ></w-radio>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialogProfil2.show = false"
                        >Tutup</w-button
                    >
                </template>
            </w-dialog>
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from "vue";
import ZenOne from "@/Shared/ZenOne";
import ZResource from "@/Modules/z-resource-service";

export default {
    extends: ZResource,
    components: {},

    props: {
        id: [Array, Object, String],
    },
    setup() {},

    data() {
        return {
            resourceurl: this.service_tunggakan + "tuntutan_bantuan",
            reload: true,
            files: [],
            // akaun_id : '',
            form_profil: {},
            dt_akaun: {},
            dt_vot: {},
            form: {
                tarikh_meninggal: null,
                tarikh_hingga: null,
                amaun_tunggakan: 0,
                amaun_bulanan: 0,
            },
            kategori: [
                {
                    value: 1,
                    label: "Individu",
                },
                {
                    value: 2,
                    label: "Syarikat",
                },
            ],

            form_cari: {},
            carian_profil: { q: "" },
            carian_profil2: { q: "" },
            profils: [],
            profils2: [],
            vot_ids: [],
            akauns: [],
            dialogProfil: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: { nama: "", email: "" },
            },
            dialogProfil2: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: { nama: "", email: "" },
            },

            form: {
                loading: false,
                no_rujukan: "",
                catatan: "",
                // vot_id : '',
            },
            isDropdownSelected: false,
            validators: {
                unique: (value) => !!value || "Medan Ini Wajib Isi",
                required: (value) => !!value || "Medan Ini Wajib Isi",
                consent: (value) => !!value || "You must agree",
                email: (value) =>
                    !!value.match(/\w+\.?\w+@\w+(\.\w+)+/i) ||
                    "Sila Semak Format Email",
                numeric: (value) => !isNaN(value) || "Medan Ini Wajib Numeric",
            },
            crumbs: [
                // { label: this.$page.props.app_name, route: '/sitemap' },
                { label: "iHasil", route: "/ihasil" },
                { label: "Bantuan Am", route: "/tuntutan_bantuan" },
                { label: "Daftar", route: "/tuntutan_bantuan/daftar" },
            ],
        };
    },
    methods: {
        updateHinggaMinDate() {
            const tunggakanDari = new Date(this.form.tunggakan_dari);
            const hinggaInput = this.$refs.hinggaInput; // reference to the Hingga input element

            if (hinggaInput) {
                hinggaInput.min = this.formatDate(tunggakanDari); // format the date as YYYY-MM-DD
                this.form.tunggakan_hingga = ""; // reset the Hingga input value
            }
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = ("0" + (date.getMonth() + 1)).slice(-2); // add leading zero if necessary
            const day = ("0" + date.getDate()).slice(-2); // add leading zero if necessary
            return `${year}-${month}-${day}`;
        },

        isCatatanPerihalSelectable() {
            // Replace '4' with the value corresponding to the fourth option in your database
            return this.form.lkp_tuntutan_bantuan_perihal_id === 4;
        },
        handlePerihalChange() {
            if (this.form.lkp_tuntutan_bantuan_perihal_id !== 4) {
                this.form.catatan = ""; // Clear the value if the selected option is not the fourth option
            }
        },

        addItem() {
            this.form.butiran.push({
                akaun_id: null,
                vot_id: null,
                no_fail: null,
                keterangan: null,
                kuantiti: 1,
                kadar: null,
                amaun: null,
                lama_vot_id: null,
            });
        },

        removeItem(index) {
            this.form.butiran.splice(index, 1);
        },

        cekAmaun() {
            this.form.amaun = 0;
            for (var i in this.form.butiran) {
                this.form.amaun =
                    this.form.amaun + parseFloat(this.form.butiran[i].amaun);
            }
        },

        cekJumlah(dt) {
            dt.amaun = dt.kuantiti * dt.kadar;
            this.cekAmaun();
            // for (var i in this.form.butiran) {
            // }
        },

        send(status) {
            this.form.loading = true;
            this.form.lkp_inbois_status_id = status;
            this.$zcomm
                .update(
                    this.resourceurl + "/" + this.form.id,
                    this.form.id,
                    this.form
                )
                .then((res) => {
                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit();
                    }
                    this.$inertia.visit(this.$route("inbois.show", res.id));
                })
                .catch((err) => {})
                .finally(() => {
                    this.form.loading = false;
                });
        },

        submitInbois() {
            // alert('asssd');
            if (this.form.id > 0) {
                if (this.form.valid == true) {
                    this.form.loading = true;
                    // this.form.valid = false
                    this.$zcomm
                        .update(
                            this.resourceurl + "/" + this.form.id,
                            this.form.id,
                            this.form
                        )
                        .then((res) => {
                            if (typeof this.onAfterEdit === "function") {
                                this.onAfterEdit();
                            }
                        })
                        .catch((err) => {})
                        .finally(() => {
                            this.form.loading = false;
                        });
                }
            } else {
                if (this.form.valid == true && this.form.profil_id != null) {
                    // this.form.valid = false
                    this.form.loading = true;
                    this.$zcomm
                        .post(this.resourceurl, this.form)
                        .then((res) => {
                            if (typeof this.onAfterAdd === "function") {
                                this.onAfterAdd();
                            }
                            this.$zutil.notify("Rekod telah berjaya dihantar");
                            this.$inertia.visit(
                                this.$route("inbois.semak", res.id)
                            );
                        })
                        .catch((err) => {})
                        .finally(() => {
                            this.form.loading = false;
                        });
                }
            }
        },

        back() {
            window.history.back();
        },

        profil(i_ind) {
            this.i_ind = i_ind;
            this.dialogProfil.show = 1;
        },
        profil2(i_ind) {
            this.i_ind = i_ind;
            this.dialogProfil2.show = 1;
        },

        cariProfil() {
            if (this.carian_profil.q.length > 1) {
                this.$zcomm
                    .post(
                        this.service_utiliti + "lookup/profil",
                        this.carian_profil,
                        {}
                    )
                    .then((res) => {
                        console.log(res);
                        this.profils = res;
                    });
            }
        },
        cariProfil2() {
            if (this.carian_profil2.q.length > 1) {
                this.$zcomm
                    .post(
                        this.service_utiliti + "lookup/profil",
                        this.carian_profil2,
                        {}
                    )
                    .then((res) => {
                        console.log(res);
                        this.profils2 = res;
                    });
            }
        },

        pilihProfil(dt) {
            this.form.profil_id = dt.value;
            this.form.data_profil = dt.label;
        },

        pilihProfil2(dt) {
            this.form.profil_id2 = dt.value;
            this.form.data_profil2 = dt.label;
        },

        getAkauns() {
            this.$zcomm
                .get(this.service_utiliti + "lookup/akaun_akhir")
                .then((res) => {
                    this.akauns = res;
                });
        },

        jumlah(form) {
            const tarikhMeninggalDate = new Date(this.form.tunggakan_dari);
            const tunggakanHinggaDate = new Date(this.form.tunggakan_hingga);

            if (!isNaN(tarikhMeninggalDate) && !isNaN(tunggakanHinggaDate)) {
                let totalAmount = 0;

                let currentDate = new Date(tarikhMeninggalDate);

                while (currentDate <= tunggakanHinggaDate) {
                    const year = currentDate.getFullYear();
                    const month = currentDate.getMonth();
                    const daysInMonth = new Date(year, month + 1, 0).getDate();

                    if (
                        currentDate.getMonth() ===
                            tarikhMeninggalDate.getMonth() &&
                        currentDate.getMonth() ===
                            tunggakanHinggaDate.getMonth()
                    ) {
                        // For the specified month, add the amount for the remaining days
                        const remainingDays =
                            daysInMonth - tarikhMeninggalDate.getDate() + 1;
                        totalAmount += parseFloat(
                            (
                                (remainingDays / daysInMonth) *
                                this.form.amaun_bulanan
                            ).toFixed(2)
                        );
                    } else if (
                        currentDate.getMonth() ===
                        tarikhMeninggalDate.getMonth()
                    ) {
                        // For the starting month, add the amount for the remaining days
                        const remainingDays =
                            daysInMonth - tarikhMeninggalDate.getDate() + 1;
                        totalAmount += parseFloat(
                            (
                                (remainingDays / daysInMonth) *
                                this.form.amaun_bulanan
                            ).toFixed(2)
                        );
                    } else if (
                        currentDate.getMonth() ===
                        tunggakanHinggaDate.getMonth()
                    ) {
                        // For the ending month, add the amount for the days up to the specified day
                        const addedDays = tunggakanHinggaDate.getDate();
                        totalAmount += parseFloat(
                            (
                                (addedDays / daysInMonth) *
                                this.form.amaun_bulanan
                            ).toFixed(2)
                        );
                    } else {
                        // For other full months in between, add the full month's amount
                        totalAmount += parseFloat(this.form.amaun_bulanan);
                    }

                    // Move to the next month
                    currentDate.setMonth(currentDate.getMonth() + 1);
                    currentDate.setDate(1); // Set the date to the first day of the month
                }

                this.form.amaun_tunggakan = totalAmount.toFixed(2);
            } else {
                this.form.amaun_tunggakan = 0;
            }
        },

        calculateTotalMonths(startDate, endDate) {
            let totalMonths =
                (endDate.getFullYear() - startDate.getFullYear()) * 12;
            totalMonths -= startDate.getMonth();
            totalMonths += endDate.getMonth() + 1;
            return totalMonths <= 0 ? 0 : totalMonths;
        },

        // jumlah(form) {
        //     var dari = form.tunggakan_dari;
        //     var hingga = form.tunggakan_hingga;

        //     var tanggal1 = new Date(dari); // format tanggal YYYY-MM-DD, tahun-bulan-hari
        //     var tanggal2 = new Date(hingga); // format tanggal YYYY-MM-DD, tahun-bulan-hari

        //     var time_difference = tanggal2.getTime() - tanggal1.getTime();
        //     var result = time_difference / (1000 * 60 * 60 * 24);
        //     var total = form.amaun_bulanan / result;
        //     this.form.amaun_tunggakan = total;
        // },
        // jumlah(form) {
        //     var meninggal = form.tarikh_meninggal;
        //     var laporan = form.tarikh_laporan;

        //     var tanggal1 = new Date(meninggal); // format tanggal YYYY-MM-DD, tahun-bulan-hari
        //     var tanggal2 = new Date(laporan); // format tanggal YYYY-MM-DD, tahun-bulan-hari

        //     var time_difference = tanggal2.getTime() - tanggal1.getTime();
        //     var result = time_difference / (1000 * 60 * 60 * 24);
        //     var total = form.amaun_bulanan / result;
        //     this.form.amaun_tunggakan = total;
        // },

        poskodDetail() {
            this.$zcomm
                .get(
                    this.service_utiliti +
                        "lookup/lkp_poskod_detail/" +
                        this.form_profil.lkp_poskod_id
                )
                .then((res) => {
                    this.form_profil.negeri = res.negeri;
                    this.form_profil.lkp_negeri_id = res.lkp_negeri_id;
                    this.form_profil.bandar = res.bandar;
                    this.form_profil.lkp_jenis_alamat_id = 1;
                });
        },

        profilDetail() {
            // alert('w234')

            this.$zcomm
                .get(this.service_utiliti + "profil/" + this.form_cari.id)
                .then((res) => {
                    this.form.profil_id = res.id;
                    this.form.no_id = res.no_id;
                    this.form.nama = res.nama;
                    this.form.alamat1 = res.alamat1;
                    this.form.alamat2 = res.alamat2;
                    this.form.alamat3 = res.alamat3;
                    this.form.poskod = res.poskod;
                    this.form.bandar = res.bandar;
                    this.form.negeri = res.negeri;
                    this.form.kategori = res.kategori;
                });
            this.dialogProfil.show = false;
        },

        submitProfil() {
            if (this.dialog.valid == true) {
                //     this.form.valid = false

                // if (this.$refs.form.validate()) {
                this.dialog.loading = true;

                this.$zcomm
                    .post(
                        this.service_bil_pelbagai + "profil",
                        this.form_profil
                    )
                    .then((res) => {
                        // console.log(res)
                        //update displayed record
                        // this.$page.flash.success = "Rekod telah ditambah"
                        this.mapreturneddata(res);
                        this.dialog.show = false;
                        if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd();
                        }
                        this.form.profil_id = res.id;
                        this.form.no_id = res.no_id;
                        this.form.nama = res.nama;
                        this.form.alamat1 = res.alamat1;
                        this.form.alamat2 = res.alamat2;
                        this.form.alamat3 = res.alamat3;
                        this.form.poskod = res.poskod;
                        this.form.bandar = res.bandar;
                        this.form.negeri = res.negeri;
                        this.form.kategori = res.kategori;
                        this.form.data_profil = res.no_id + " | " + res.nama;
                        // this.$inertia.visit(this.$page.url)
                    })
                    .finally(() => {
                        this.dialog.loading = false;

                        // $('#' + this.resourceurl).modal('hide')
                    });
                this.cariProfil();
            }
        },
        reset() {
            this.form = {
                show: true,
            };
        },

        send(ind) {
            if (ind == 1) {
                if (
                    this.form.lkp_tuntutan_bantuan_status_id == 1 ||
                    this.form.lkp_tuntutan_bantuan_status_id == 5
                ) {
                    this.form.lkp_tuntutan_bantuan_status_id = 2;
                }
            } else {
                this.form.lkp_tuntutan_bantuan_status_id = 6;
            }
            this.$zcomm
                .update(
                    this.resourceurl + "/" + this.form.id,
                    this.form.id,
                    this.form
                )
                .then((res) => {
                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit();
                    }
                    this.$inertia.visit(this.$route("bantuan.show"));
                })
                .catch((err) => {})
                .finally(() => {});
        },
        // onSuccess() {
        //     if (
        //         this.form.profil_id &&
        //         this.form.profil_waris_id &&
        //         this.form.lkp_tuntutan_bantuan_skim_id &&
        //         this.form.lkp_tuntutan_bantuan_perihal_id &&
        //         this.form.no_rujukan &&
        //         this.form.tarikh_laporan &&
        //         this.form.tunggakan_dari &&
        //         this.form.tunggakan_hingga &&
        //         this.form.tunggakan_meninggal &&
        //         this.form.catatan &&
        //         this.form.amaun_tunggakan &&
        //         this.form.amaun_bulanan &&
        //         this.files
        //     ) {
        //         this.btnStatus = true;
        //         this.$zcomm
        //             .post(this.resourceurl, this.form)
        //             .then((res) => {
        //                 if (typeof this.onAfterAdd === "function") {
        //                     this.onAfterAdd();
        //                 }
        //                 this.upload(res.id);
        //                 this.$zutil.notify("Rekod Telah Berjaya Dihantar");
        //                 this.$inertia.visit(this.$route("bantuan.show"));
        //             })
        //             .catch((err) => {
        //                 console.log(err);
        //             })
        //             .finally(() => {});
        //     }
        // },

        onSuccess() {
            if (this.form.id > 0) {
                this.$zcomm
                    .update(
                        this.resourceurl + "/" + this.form.id,
                        this.form.id,
                        this.form
                    )
                    .then((res) => {
                        if (typeof this.onAfterEdit === "function") {
                            this.onAfterEdit();
                        }
                    })
                    .catch((err) => {})
                    .finally(() => {});
            } else {
                this.$zcomm
                    .post(this.resourceurl, this.form)
                    .then((res) => {
                        if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd();
                        }
                        this.upload(res.id);
                        this.$zutil.notify("Rekod telah berjaya Daftar");
                        this.$inertia.visit(
                            this.$route("bantuan.show", res.id)
                        );
                    })
                    .finally(() => {
                        // $('#' + this.resourceurl).modal('~hide')
                    });
            }
        },

        upload(id) {
            let formData = new FormData();
            formData.append("file", this.files[0].file);
            formData.append("model", "App\\Models\\TuntutanBantuan");
            formData.append("model_id", id);
            this.$zcomm
                .post(this.resourceurl + "/upload", formData)
                .then((res) => {
                    if (typeof this.onAfterAdd === "function") {
                        this.onAfterAdd();
                    }
                    this.$zutil.notify("Rekod telah berjaya dihantar");

                    // this.getData();
                    // this.activeTab = 1;
                    // this.submitLoading=true;
                    // this.$inertia.visit(this.$route('pendidikan.index'));
                })
                .catch((err) => {})
                .finally(() => {});
        },
    },
    watch: {
        "form_profil.lkp_poskod_id": function (q) {
            this.poskodDetail();
        },

        "form_cari.id": function (q) {
            this.profilDetail();
        },
    },

    mounted() {
        if (this.id == 0) {
            this.form = {
                show: true,
            };
        }
    },
};
</script>

<style>
.w-select__menu {
    z-index: 999999;
}
</style>
